// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__nd2dh","header":"styles_header__7S8Lu","list":"styles_list__3XTf4"};